// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2024-09-17 15:19:47 +0200 (Tue, 17 Sep 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 145847 $
//  Purpose   : uix gndo support
// =============================================================================

export const templates = true
export const parts = true

import * as views from './views'
export {views}

export const dashpanels = true
